<template>
  <div class="ring-container">
    <div class="ringring"></div>
    <div class="circle"></div>
  </div>
</template>
<style lang="scss" scoped src="./live-circle.scss"></style>
<script lang="ts" src="./live-circle.ts"></script>
